export default __webpack_public_path__ + "static/media/vietnam.bfaa8ae3.svg";